export const openSignIn = () => {
    return {type: 'OPEN_SIGN_IN'};
};

export const closeSignIn = () => {
    return {type: 'CLOSE_SIGN_IN'};
};